import { inject, Injectable } from '@angular/core';
import { AuthFacadeService } from '../../domain/auth/service/auth-facade.service';

export const SESSION_TIMEOUT_MS = 60 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class SessionTimeoutService {
  private readonly authFacade = inject(AuthFacadeService);
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  start(): void {
    this.reset();
  }

  reset(): void {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => this.onTimeout(), SESSION_TIMEOUT_MS);
  }

  stop(): void {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private onTimeout(): void {
    this.timeoutId = null;
    this.authFacade.sessionTimeout();
  }
}
